// extracted by mini-css-extract-plugin
module.exports = {"inviteForm":"BoardModal_inviteForm__2MUF8"};